/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// 20250326 カート内商品数に基づいて配送日時指定アプリの表示を制御するスクリプト
document.addEventListener("DOMContentLoaded", function () {
  // カートページかどうかを確認
  function isCartPage() {
    // URLにcartが含まれるか確認
    if (window.location.pathname.includes("/cart")) {
      return true;
    }

    // カートセクションの存在を確認
    return !!document.querySelector(
      '[data-section-type="cart"], form[action="/cart"]'
    );
  }

  // カートページでない場合は何もしない
  if (!isCartPage()) {
    return;
  }

  // 配送日時指定アプリを見つける - 特定のIDとクラスに限定
  function findDeliveryDateSelector() {
    // 明確なセレクタのみを使用
    return document.querySelector(
      "#js-joc-dds, .joc-dds, #shopify-block-Aemx2Z0hGaTdZYmE0M__japan_order_csv_dds_UqVDpp"
    );
  }

  // カートが空かどうかを判断する関数（シンプルに保つ）
  function isCartEmpty() {
    // 方法1: data-section-settings から確認（最も信頼性が高い）
    const cartSection = document.querySelector('[data-section-type="cart"]');
    if (cartSection) {
      try {
        const sectionSettings = JSON.parse(
          cartSection.getAttribute("data-section-settings") || "{}"
        );
        if (typeof sectionSettings.itemCount === "number") {
          return sectionSettings.itemCount === 0;
        }
      } catch (e) {}
    }

    // 方法2: EmptyStateクラスの存在を確認（Shopifyの標準パターン）
    if (document.querySelector(".EmptyState")) {
      return true;
    }

    // 方法3: Cart--emptyクラスを確認（Shopifyの標準パターン）
    const cartElement = document.querySelector(".Cart");
    if (cartElement && cartElement.classList.contains("Cart--empty")) {
      return true;
    }

    // デフォルトでは空ではないと仮定
    return false;
  }

  // アプリの表示状態を更新
  function updateAppVisibility() {
    const deliveryApp = findDeliveryDateSelector();
    if (!deliveryApp) {
      return; // アプリが見つからない場合は何もしない
    }

    const cartEmpty = isCartEmpty();

    // 日本語の配送日時指定アプリを探して非表示にする
    if (cartEmpty) {
      deliveryApp.style.display = "none";

      // アプリを含む親のshopify-blockがあれば非表示
      const appBlock = deliveryApp.closest(
        ".shopify-block, .shopify-app-block"
      );
      if (appBlock) {
        appBlock.style.display = "none";
      }
    } else {
      deliveryApp.style.display = "";

      // アプリを含む親のshopify-blockがあれば表示
      const appBlock = deliveryApp.closest(
        ".shopify-block, .shopify-app-block"
      );
      if (appBlock) {
        appBlock.style.display = "";
      }
    }
  }

  // APIを使用してカート状態を確認（バックアップとして）
  function checkCartViaAPI() {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        const deliveryApp = findDeliveryDateSelector();
        if (!deliveryApp) return;

        if (cart.item_count === 0) {
          deliveryApp.style.display = "none";
          // アプリを含む親のshopify-blockがあれば非表示
          const appBlock = deliveryApp.closest(
            ".shopify-block, .shopify-app-block"
          );
          if (appBlock) {
            appBlock.style.display = "none";
          }
        } else {
          deliveryApp.style.display = "";
          // アプリを含む親のshopify-blockがあれば表示
          const appBlock = deliveryApp.closest(
            ".shopify-block, .shopify-app-block"
          );
          if (appBlock) {
            appBlock.style.display = "";
          }
        }
      })
      .catch((error) => {
        console.error("カート情報の取得に失敗しました", error);
      });
  }

  // Ensure visibility logic applies to mobile devices
  function isMobile() {
    return window.matchMedia("only screen and (max-width: 768px)").matches;
  }

  function updateAppVisibilityForMobile() {
    if (!isMobile()) return; // Only apply for mobile

    const deliveryApp = findDeliveryDateSelector();
    if (!deliveryApp) {
      return;
    }

    const cartEmpty = isCartEmpty();

    if (cartEmpty) {
      deliveryApp.style.display = "none";
      const appBlock = deliveryApp.closest(
        ".shopify-block, .shopify-app-block"
      );
      if (appBlock) {
        appBlock.style.display = "none";
      }
    } else {
      deliveryApp.style.display = "";
      const appBlock = deliveryApp.closest(
        ".shopify-block, .shopify-app-block"
      );
      if (appBlock) {
        appBlock.style.display = "";
      }
    }
  }

  // 初期表示の設定
  updateAppVisibility();
  updateAppVisibilityForMobile();
  checkCartViaAPI(); // バックアップでAPI経由でも確認

  // カート更新イベントの監視（カートページ用の最も一般的なイベント）
  const cartEvents = [
    "cart:updated",
    "cart:refresh",
    "cart.requestComplete",
    "ajax:success",
    "product:added",
  ];

  cartEvents.forEach((event) => {
    document.addEventListener(event, function () {
      setTimeout(updateAppVisibility, 300);
      setTimeout(updateAppVisibilityForMobile, 300);
    }); // Close the event listener properly
  });

  // バックアップとしてのCSS - 非常に特定のセレクタのみ使用
  function addEmptyCartCSS() {
    const styleEl = document.createElement("style");
    styleEl.type = "text/css";
    styleEl.innerHTML = `
      /* カートが空の場合の非表示ルール - 特定のセレクタのみ */
      .EmptyState ~ #js-joc-dds,
      .EmptyState ~ .joc-dds,
      .EmptyState ~ .shopify-app-block #js-joc-dds,
      .EmptyState ~ .shopify-app-block .joc-dds,
      .Cart--empty #js-joc-dds,
      .Cart--empty .joc-dds,
      .Cart--empty .shopify-app-block #js-joc-dds,
      .Cart--empty .shopify-app-block .joc-dds {
        display: none !important;
      }
    `;
    document.head.appendChild(styleEl);
  }

  addEmptyCartCSS();
});
